<div class="cr-card">
  <div
    *ngIf="header"
    class="cr-card__section"
    [class.cr-card__header--large]="large"
  >
    <ng-content select="card-header"></ng-content>
  </div>
  <hr *ngIf="header" />

  <div
    *ngIf="body"
    class="cr-card__section"
    [class.cr-card__section--large]="large"
  >
    <ng-content select="card-body"></ng-content>
  </div>
  <hr *ngIf="body" />

  <div
    *ngIf="footer"
    class="cr-card__section"
    [class.cr-card__footer--large]="large"
  >
    <ng-content select="card-footer"></ng-content>
  </div>
</div>
